import React from 'react';

import { AmountSelector } from './components/AmountSelector';
import { ValidationError } from './components/ValidationError';
import { useImpressionAmountSelector } from './hooks/useImpressionAmountSelector';

export const ImpressionAmountSelector: React.FC = () => {
	const {
		data: { ref },
	} = useImpressionAmountSelector();

	return (
		<div data-testid="promotion-impression-amount-selector" className="flex flex-col gap-3" ref={ref}>
			<ValidationError />
			<AmountSelector />
		</div>
	);
};
